import { useQuery } from '@tanstack/react-query';
import { getDocumentWorkflowTemplateById } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import { useMasterDocumentsEndpoints } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useMasterDocumentsEndpoints.ts';

export const useMasterDocumentQuery = (documentId: string | null, enabled: boolean) => {
	const { byId } = useMasterDocumentsEndpoints();
	const detailKey = byId(documentId ?? '');

	return useQuery({
		queryKey: [detailKey],
		queryFn: () => getDocumentWorkflowTemplateById(detailKey),
		enabled: !!documentId && enabled,
	});
};
